import angular from 'angular';
import PaginationComponent from './pagination.component';
import PaginationConstants from './pagination.constants';

const paginationModule = angular.module('tinaba.common.pagination', [])

.component('pagination', PaginationComponent)

.constant('PaginationSettings', PaginationConstants);

export default paginationModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination/pagination.js
 **/